interface ReferralData {
  referrer_url?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
  ref_param?: string;
  landing_page?: string;
  first_visit_at?: string;
}

const REFERRAL_STORAGE_KEY = 'ai_humanizer_referral_data';

export class ReferralTracker {
  static capture(): void {
    // Only capture if we don't already have referral data stored
    const existing = localStorage.getItem(REFERRAL_STORAGE_KEY);
    if (existing) return;

    const urlParams = new URLSearchParams(window.location.search);
    const referralData: ReferralData = {
      referrer_url: document.referrer || undefined,
      utm_source: urlParams.get('utm_source') || undefined,
      utm_medium: urlParams.get('utm_medium') || undefined,
      utm_campaign: urlParams.get('utm_campaign') || undefined,
      utm_content: urlParams.get('utm_content') || undefined,
      utm_term: urlParams.get('utm_term') || undefined,
      ref_param: urlParams.get('ref') || undefined,
      landing_page: window.location.href,
      first_visit_at: new Date().toISOString()
    };

    // Only store if we have at least one meaningful referral source
    const hasReferralData = referralData.referrer_url || 
                           referralData.utm_source || 
                           referralData.ref_param;

    if (hasReferralData) {
      localStorage.setItem(REFERRAL_STORAGE_KEY, JSON.stringify(referralData));
    }
  }

  static getReferralData(): ReferralData | null {
    const stored = localStorage.getItem(REFERRAL_STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  }

  static clearReferralData(): void {
    localStorage.removeItem(REFERRAL_STORAGE_KEY);
  }

  static formatReferralSource(data: ReferralData): string {
    if (data.utm_source) return data.utm_source;
    if (data.ref_param) return `ref: ${data.ref_param}`;
    if (data.referrer_url) {
      try {
        return new URL(data.referrer_url).hostname;
      } catch {
        return 'Direct/Unknown';
      }
    }
    return 'Direct/Unknown';
  }
}